import angular from 'angular';

angular.module('cloudX').filter('bytes', [bytesFilter]);

function bytesFilter() {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  return function(bytes, decimals) {
    if (!bytes) return '0 Bytes';
    var k = 1024,
      dm = typeof decimals === 'undefined' || decimals < 0 ? 2 : decimals,
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };
}
